import React from "react";

import { Checkbox } from "../../components/ui";
import { useRequestLookbook } from "./useRequestLookbook";

/**
 * Wraps one Orders-list row while the lookbook overlay is open: a checkbox in
 * front of the record, and the whole card as a hit target.
 *
 * Ticking it moves the request into the tray above the list, so a picked request
 * is never shown twice — it leaves the list and appears at the top, where it can
 * be reordered or unticked again.
 *
 * The row underneath is the real thing — same card, same data — but inert: its
 * own links, star and action buttons are switched off (see `.rlb-pick__body`) so
 * a click while picking can only ever mean "add this to the lookbook", never
 * "open the quote panel".
 */
export const PickableRequest = ({ item, children }) => {
  const { isSelected, toggle } = useRequestLookbook();

  if (isSelected(item.id)) {
    return null;
  }

  const label = [item?.product?.brand?.name, item?.product?.model?.name]
    .filter(Boolean)
    .join(" ");

  return (
    <div className="rlb-pick" onClick={() => toggle(item)}>
      <Checkbox
        checked={false}
        onChange={() => toggle(item)}
        aria-label={`Add request ${item.id}${label ? ` — ${label}` : ""} to the lookbook`}
        onClick={(e) => e.stopPropagation()}
      />

      <div className="rlb-pick__body">{children}</div>
    </div>
  );
};

export default PickableRequest;
